/**
 * RedRoomGuardC.js
 * The Red-Room Guard C Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class RedRoomGuardC extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, 1);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        // Single ability choice
        let addBubbleData = {
            nbBubbles: this._nbBubblesAdd,
            color: BubbleColor.eRANDOM,
            startPos: startPos,
            dodgeFirst: false,
            callback: this._onAbilityCompleted.bind(this)
        };
        Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleData);
    }
}
